import { useCallback, useEffect, useMemo, useState } from 'react'
import { useWireValue } from '@forminator/react-wire'
import * as store from '@store'
import * as actions from '@actions'
import { Link } from 'react-router-dom'

/* type FavoritePropTypes = {
    projects: Project[]
    user: User
    setUpdateList: (isUpdateList: boolean) => void
    isUpdateList: boolean
    projectEdit: Function
    projectDelete: (id: string, name: string) => void
    checkFavoriteProject: (id: string, isAdd: boolean) => void
} */

const FavoriteRecentProjects = ({
    user,
    projects,
    isUpdateList,
    projectEdit,
    projectDelete,
    checkFavoriteProject,
}) => {
    
    // viewedProject: UseProjectData[]
    const viewedProject = useWireValue(store.currentProject)
    
    // @todo the setter here is never called??
    const [isArrowFavorite /* setHideArrowFavorite */] = useState(false)
    
    const favoriteProjectList = useMemo(() => {
        const favoriteProjects = []
        
        user.favoriteProjects?.forEach(({ UserProjectJoin }) => {
            projects.forEach(project => {
                if (UserProjectJoin.ProjectId === project.id) {
                    favoriteProjects.push({ ...project, userId: UserProjectJoin.UserId })
                }
            })
        })
        return favoriteProjects
    }, [projects, user.favoriteProjects])
    
    const viewProjects = useCallback(
        
        // projectsList: UseProjectData[]
        (projectsList = viewedProject) => {
            const projectList = projectsList?.map(project => ({ ...project, isFavorite: false }))
            
            user.favoriteProjects?.forEach(favorite => {
                projectList.forEach(project => {
                    if (favorite.id === project.projectId) {
                        project.isFavorite = true
                    }
                })
            })
            return projectList
        },
        [user.favoriteProjects, viewedProject],
    )
    
    // const replaceProject = (project: UseProjectData) => {
    const replaceProject = project => {
        const replaceData = { ...project }
        
        replaceData.name = replaceData.projectName
        replaceData.id = replaceData.projectId
        
        delete replaceData.projectName
        delete replaceData.projectId
        delete replaceData.userId
        
        projectEdit(replaceData)
    }
    
    useEffect(() => {
        actions.fetchRecentProjects(user.id)
    }, [user.id, isUpdateList])
    
    return (
        <div className="mt-3 row">
            <div className="pr-1 col-6">
                <div className="pb-1 ml-1 row">
                    <div className="mb-3 col-10">Favorite Projects</div>
                    <div className="pl-1 text-right col-2">
                        {isArrowFavorite ? (
                            <i
                                className="fe fe-arrow-up icon-mid "
                                onClick={() => {
                                    
                                    // @todo wtf is this
                                    // eslint-disable-next-line no-restricted-globals
                                    const elm = document.getElementById('scrollId')
                                    
                                    elm.scrollIntoView({ behavior: 'smooth' })
                                }} />
                        ) : (
                            <i />
                        )}
                    </div>
                </div>
                <div className="mr-2" id="favScroll">
                    <div style={{ maxHeight: '260px', overflowY: 'scroll' }}>
                        <div className="" id="scrollId" style={{ maxWidth: '98%' }}>
                            {(favoriteProjectList?.map(project => (
                                <div className="list-group-item favorite-projects" key={project.id}>
                                    <div className="row ">
                                        <span className="col-8 align-self-center">
                                            <Link className="text-right col-6" to={`/project/${project.id}`}>
                                                {project.name}
                                            </Link>
                                        </span>
                                        <span className="text-right col-4">
                                            <>
                                                <span className="col-7">
                                                    <i
                                                        className="fe fe-star-fill icon-mid"
                                                        onClick={() => checkFavoriteProject(project.id, true)} />
                                                </span>
                                                <i
                                                    className="mr-3 fe fe-edit-2 pointer-cursor"
                                                    onClick={() => projectEdit(project)} />
                                                <i
                                                    className="fe fe-trash pointer-cursor"
                                                    onClick={() => projectDelete(project.id, project.name)} />
                                            </>
                                        </span>
                                    </div>
                                </div>
                            ))) ||
                            ''}
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-6">
                <div className="pb-1">
                    <div className="mb-3 col-10">Recent Projects</div>
                </div>
                <div>
                    {(viewProjects &&
                        viewProjects(viewedProject)?.map(project => (
                            <div
                                className="list-group-item"
                                style={{
                                    minHeight: '60px',
                                    border: '3px solid #243a59',
                                    borderRadius: '8px',
                                    backgroundColor: '#152e4d',
                                }}
                                key={project.projectId}>
                                <div className="row">
                                    <span className="col-6 align-self-center">
                                        <Link className="text-right col-6" to={`/project/${project.projectId}`}>
                                            {project.projectName}
                                        </Link>
                                    </span>
                                    <span className="text-right col-6">
                                        <i
                                            className={
                                                (project.isFavorite && 'fe fe-star-fill icon-mid') ||
                                                'fe fe-star icon-mid'
                                            }
                                            id={project.projectName}
                                            onClick={() => checkFavoriteProject(
                                                project.projectId,
                                                project.isFavorite,
                                            )} />
                                        <i
                                            className="ml-3 mr-3 fe fe-edit-2 pointer-cursor"
                                            onClick={() => replaceProject(project)} />
                                        <i
                                            className="fe fe-trash pointer-cursor"
                                            onClick={() => projectDelete(project.projectId, project.projectName)} />
                                    </span>
                                </div>
                            </div>
                        ))) ||
                        ''}
                </div>
            </div>
        </div>
    )
}

export default FavoriteRecentProjects
